
export const TICKET_STATUSES = [
  'new',
  'assigned',
  'in_progress',
  'waiting_for_requester',
  'on_approval',
  'approved',
  'not_approved',
  'rejected',
  'withdrawn',
  'resolved',
  'closed',
] as const;

export type TicketStatus = (typeof TICKET_STATUSES)[number];

export const TICKET_STATUS_LABELS: Record<TicketStatus, string> = {
  new: 'Новая',
  assigned: 'Назначена',
  in_progress: 'В работе',
  waiting_for_requester: 'Требует уточнения',
  on_approval: 'На согласовании',
  approved: 'Согласована',
  not_approved: 'Не согласована',
  rejected: 'Отклонена',
  withdrawn: 'Отозвана',
  resolved: 'Выполнено, требует подтверждения',
  closed: 'Закрыта',
};

export const TERMINAL_TICKET_STATUSES = ['closed', 'withdrawn', 'rejected'];

export function isTicketFinal(ticket: { status?: string | null; isFinal?: boolean | null } | null | undefined): boolean {
  if (!ticket) return false;
  return Boolean(ticket.isFinal) || TERMINAL_TICKET_STATUSES.includes(ticket.status ?? '');
}

export const WITHDRAWABLE_STATUSES: string[] = ['new', 'assigned'];

export const APPROVAL_BLOCKED_STATUSES = [
  'resolved',
  'not_confirmed',
  'closed',
  'withdrawn',
  'rejected',
];

export const MAX_TICKET_DESCRIPTION_LENGTH = 5000;
export const MAX_MESSAGE_LENGTH = 4000;

export const TICKET_PRIORITIES = ['low', 'medium', 'high', 'critical'] as const;

export type TicketPriority = (typeof TICKET_PRIORITIES)[number];

export const TICKET_PRIORITY_LABELS: Record<TicketPriority, string> = {
  low: 'Низкий',
  medium: 'Средний',
  high: 'Высокий',
  critical: 'Критический',
};


export function ticketStatusLabel(status: string, statusLabel?: string | null): string {
  return statusLabel ?? TICKET_STATUS_LABELS[status as TicketStatus] ?? status;
}

export type TicketStatusTone =
  | 'neutral'
  | 'pending'
  | 'info'
  | 'accent'
  | 'review'
  | 'warning'
  | 'positive'
  | 'danger';

const TICKET_STATUS_TONES: Record<string, TicketStatusTone> = {
  withdrawn: 'neutral',
  new: 'pending',
  assigned: 'accent',
  in_progress: 'info',
  on_approval: 'review',
  approved: 'positive',
  closed: 'positive',
  waiting_for_requester: 'warning',
  resolved: 'warning',
  not_confirmed: 'warning',
  not_approved: 'danger',
  rejected: 'danger',
};

export function ticketStatusTone(status: string): TicketStatusTone {
  return TICKET_STATUS_TONES[status] ?? 'info';
}
